import { useNavigate } from '@tanstack/react-router'
import { Onglets } from './Ui'

const PAGES = {
  entites: '/entites',
  tiers: '/tiers',
  personnes: '/personnes',
} as const

export type PageReferentiel = keyof typeof PAGES

/** Les trois pages du référentiel, réunies sous une seule entrée du menu. */
export function OngletsReferentiel({ actif }: { actif: PageReferentiel }) {
  const naviguer = useNavigate()
  return (
    <Onglets
      valeur={actif}
      onChange={(v) => void naviguer({ to: PAGES[v] })}
      onglets={[
        { valeur: 'entites', libelle: 'Entités', icone: 'domain' },
        { valeur: 'tiers', libelle: 'Tiers', icone: 'handshake' },
        { valeur: 'personnes', libelle: 'Personnes', icone: 'group' },
      ]}
    />
  )
}
